import React, { useState, useEffect } from 'react';
import { styled, Button } from '@teko/ui';

const StyledButton = styled(Button)(({ readOnly }) => `
  padding: 0px;
  pointer-events: ${readOnly ? "none" : "auto"};
`);
const RatingStars = ({
  stars,
  onStarClicked,
  starWidth = 12,
  readOnly = false,
  className
}) => {
  const [rating, setRating] = useState(stars);
  const clickStar = (star) => {
    setRating(star);
    onStarClicked && onStarClicked(star);
  };
  useEffect(() => {
    setRating(stars);
  }, [stars]);
  return /* @__PURE__ */ React.createElement("div", {
    className
  }, Array.from(Array(5).keys()).map((i) => {
    return /* @__PURE__ */ React.createElement(StyledButton, {
      key: `star-${i}`,
      icon: {
        name: "star",
        size: starWidth,
        color: i <= Math.round(rating - 1) ? "#ffd124" : "#d2d2d2"
      },
      link: true,
      block: false,
      disabled: readOnly,
      onClick: () => clickStar(i + 1),
      readOnly
    });
  }));
};

export { RatingStars };
